<template>
  <div class="page" v-wechat-title="$route.meta.title='系统维护中'">

    <div class="not-found">
      <img src="../../assets/system_02.png" alt="" style="width: 68vw;">
    </div>


  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        res: {}
      }
    },
    computed: {

    },
    created() {
      this.$loading.hide();
    },
    methods: {

    },
    components: {

    },

  }

</script>

<style scoped>

  .not-found{ padding-top: 30%; margin: 0 auto; text-align: center;  }
  .not-found img{ width: 60%; height: auto;  }
  .not-found p{margin-top:.2rem; font-size: .3rem; color: #999; line-height: .4rem;  }
</style>



// WEBPACK FOOTER //
// src/page/400/401.vue